<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#004A97" />
  <circle cx="21" cy="14" r="5.5" stroke="#FFFFFF" stroke-width="1.6" />
  <circle cx="27" cy="14" r="5.5" stroke="#FFFFFF" stroke-width="1.6" />
  <path d="M21 9.5V18.5M27 9.5V18.5" stroke="#FFFFFF" stroke-width="1" />
</svg>
